<template>
    <AINotebookPage />
  </template>
  
  <script setup lang="ts">
  import AINotebookPage from '@/pages/AINotebookPage.vue'
  </script>
  